import React from 'react'
import { activityData } from '../../helper/constant'
import SingleCard from './SingleCard'
import { useTranslation } from 'react-i18next';

export default function MaterialStatistic() {
  const { t } = useTranslation();
  return (<>
    <div className="grid grid-cols-3 lg:grid-cols-2 md:!grid-cols-1 gap-5 mt-5 md:mt-14">
      <div>
        <SingleCard
          tab={[t("mostactive"), t("passive")]}
          title={t("activity")}
          data={activityData}
        />
      </div>
      <div>
        {" "}
        <SingleCard
          tab={[t("best"), t("worst")]}
          title={t("result")}
          data={activityData}
          percentage={true}
        />
      </div>
      <div>
        <h4 className="text-base font-semibold">
          {t("general")} {t(" Statistics")}
        </h4>

        <h5 className="text-sm text-lightgray mt-5">
          {t("average")} {t("activity")}
        </h5>
        <h6 className="text-lg font-semibold">1:34</h6>

        <h5 className="text-sm text-lightgray mt-5">
          {t("general")} {t("activity")}
        </h5>
        <h6 className="text-lg font-semibold">19:12</h6>

        <h5 className="text-sm text-lightgray mt-5">
          {t("average")} {t("result")}
        </h5>
        <h6 className="text-lg font-semibold">64%</h6>
      </div>
    </div>
  </>)
}
